import { Badge, Box, Flex } from '@radix-ui/themes';
import { CommonCallout } from 'components/common/callouts';
import { t } from 'i18next';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { PitchListOwner } from 'lib_ts/enums/pitch-list.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IPitchList } from 'lib_ts/interfaces/pitches';

export const isSharedPitchList = (list: Pick<IPitchList, '_parent_def'>) =>
  list._parent_def === PitchListOwner.Team ||
  list._parent_def === PitchListOwner.Machine;

const getSharedListBadge = (list: IPitchList) => {
  switch (list._parent_def) {
    case PitchListOwner.Team:
      return (
        <Badge size="1" color={RADIX.COLOR.NEUTRAL}>
          {t('common.team')}
        </Badge>
      );

    case PitchListOwner.Machine:
      return (
        <Badge size="1" color={RADIX.COLOR.NEUTRAL}>
          {t('common.machine')}
        </Badge>
      );

    default:
      return null;
  }
};

export const SharedListDeleteWarning = (props: { lists: IPitchList[] }) => {
  if (!props.lists.some(isSharedPitchList)) {
    return null;
  }

  return (
    <Box mt="3">
      <CommonCallout
        color={RADIX.COLOR.DANGER}
        text="pl.warning-delete-shared-lists"
      />
    </Box>
  );
};

export const SharedListDeleteConfirmation = (props: {
  lists: IPitchList[];
}) => (
  <Box>
    <p>{t('pl.confirm-delete-following')}</p>

    {props.lists.length > 0 && (
      <ul>
        {[...props.lists]
          .sort((a, b) => {
            if (a.folder === b.folder) {
              return StringHelper.safeSort(a.name, b.name);
            }

            return StringHelper.safeSort(a.folder, b.folder);
          })
          .map((list) => (
            <li key={list._id}>
              <Flex align="center" gap="2" display="inline-flex">
                {list.folder}/{list.name || t('pl.unnamed-pitch-list')}
                {getSharedListBadge(list)}
              </Flex>
            </li>
          ))}
      </ul>
    )}

    <SharedListDeleteWarning lists={props.lists} />
  </Box>
);
